import { IOptionType } from '../../api/candidate/exam/model';
import { GET_MOTHER_TONGUE_LANGUAGES } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';

// =============================================================================
// Request & Response Model
// =============================================================================

// =============================================================================
// Mutation
// =============================================================================

interface GetMotherTongueLanguagesProps {
  onSuccess: () => void;
}

export const useGetMotherTongueLanguages = ({ onSuccess }: GetMotherTongueLanguagesProps) => {
  const getMotherTongueLanguages = async () => {
    const res = await axiosClient.get<IOptionType[]>(GET_MOTHER_TONGUE_LANGUAGES);

    return res.data;
  };

  return useCustomQuery([GET_MOTHER_TONGUE_LANGUAGES], getMotherTongueLanguages, { onSuccess });
};
